import { api } from "./client";
import type { Reference } from "../types";

export interface ReferenceBuildResult {
  updated: number;
  selected_count: number;
  ready_count: number;
  missing_reference_ids: string[];
}

export async function buildReferences(
  projectId: string,
): Promise<ReferenceBuildResult> {
  const { data } = await api.post<ReferenceBuildResult>(
    `/projects/${projectId}/build-references`,
    {},
  );
  return data;
}

export async function getReferences(projectId: string): Promise<Reference[]> {
  const { data } = await api.get<Reference[]>(`/projects/${projectId}/references`);
  return data;
}
